document.addEventListener("DOMContentLoaded", function() {
  var readMoreBtn = document.querySelector('.read-more-btn');
  var readLessBtn = document.querySelector('.read-less-btn');
  var fullContent = document.querySelector('.full-content');
  var shortContent = document.querySelector('.short-content');

  readMoreBtn.addEventListener('click', function() {
    fullContent.style.display = 'block';
    readMoreBtn.style.display = 'none';
    readLessBtn.style.display = 'inline';
    shortContent.classList.add('no-opacity'); // Ajouter la classe pour désactiver l'effet de transparence
  });

  readLessBtn.addEventListener('click', function() {
    fullContent.style.display = 'none';
    readMoreBtn.style.display = 'inline';
    readLessBtn.style.display = 'none';
    shortContent.classList.remove('no-opacity'); // Supprimer la classe pour réactiver l'effet de transparence
  });
});